import React, {Component} from 'react';
import SummaryChart from "../SummaryChart";
import {compose} from "redux";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {getTaskStatusReport} from "../../../actions/reports";
import {buildSummaryChartData} from "../../../projections";
import * as PropTypes from "prop-types";
import {subdocumentStatusReportSelector} from "../selectors";

class TaskSummary extends Component {
  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  render() {
    const { summary, title, onClick } = this.props;
    const chartData = buildSummaryChartData(summary);
    return (
      <SummaryChart
        title={title}
        data={chartData}
        onClick={onClick}
      />
    );
  }
}

TaskSummary.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default compose(
  withRouter,
  connect(
    (state, props) => ({
      summary: subdocumentStatusReportSelector(state, { path: 'tasks', code: 'taskstatus' })
    }),
    (dispatch, props) => ({
      onMount: () => dispatch(getTaskStatusReport({id: props.match.params.id}))
    })
  )
)(TaskSummary);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/TaskSummary.js